import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgs/logo.png'
import _imports_1 from '@/assets/imgs/icon_home.png'
import _imports_2 from '@/assets/imgs/icon_coop.png'
import _imports_3 from '@/assets/imgs/icon_res.png'
import _imports_4 from '@/assets/imgs/icon_proj.png'
import _imports_5 from '@/assets/imgs/icon_coin.png'
import _imports_6 from '@/assets/imgs/icon_student.png'
import _imports_7 from '@/assets/imgs/icon_soldier.png'
import _imports_8 from '@/assets/imgs/icon_sick.png'
import _imports_9 from '@/assets/imgs/icon_yg.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "项目、合伙、资金一站式对接，成就合作新机遇！")
], -1)
const _hoisted_5 = { class: "links" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "找合伙", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "找资源", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "找项目", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "找资金", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "大学生创业", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "退伍军人创业", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "残疾人创业", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "月光宝盒", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "吐槽", -1)
const _hoisted_25 = { class: "user_center" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "el-dropdown-link" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_29 = { key: 1 }

import * as user from '@/libs/user'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { computed, reactive, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useStore()
const route = useRoute()
const pageData = reactive({
  userinfo: {},
})
const isCurrent = (p: string) => {
  let path = route.path
  console.log('path', path, p)
  if (path == p) {
    return 'current'
  } else {
    const type = route.query.type
    if (type) {
      path += '?type=' + type
      if (path == p) {
        return 'current'
      }
    }
  }
  return ''
}
const mounted = async () => {
  const userinfo = await user.getUserInfo()
  if (userinfo) {
    pageData.userinfo = { ...userinfo }
  }
  store.dispatch('user/checkUserInfo')
}
const stateUserInfo = computed(() => {
  return store.state.user.info
})
watch(stateUserInfo, newinfo => {
  if (newinfo) {
    pageData.userinfo = { ...newinfo }
  }
})
const handleCommand = (cmd: string) => {
  switch (cmd) {
    case 'logout':
      store.dispatch('user/logout')
      break
  }
}
mounted()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: _normalizeClass(isCurrent('/'))
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/coop",
            class: _normalizeClass(isCurrent('/coop'))
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/resource",
            class: _normalizeClass(isCurrent('/resource'))
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/project",
            class: _normalizeClass(isCurrent('/project'))
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/fund",
            class: _normalizeClass(isCurrent('/fund'))
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/news?type=student",
            class: _normalizeClass(isCurrent('/news?type=student'))
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _hoisted_17
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/news?type=soldier",
            class: _normalizeClass(isCurrent('/news?type=soldier'))
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/news?type=sick",
            class: _normalizeClass(isCurrent('/news?type=sick'))
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          }, 8, ["class"]),
          _createTextVNode(" '"),
          _createVNode(_component_router_link, {
            to: "/app",
            class: _normalizeClass(isCurrent('/app'))
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _hoisted_23
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/comment",
            class: _normalizeClass(isCurrent('/comment'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_icon, { icon: "icon_comment" }),
              _hoisted_24
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (pageData.userinfo.userNickname || pageData.userinfo.username)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
              _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                        default: _withCtx(() => [
                          _createTextVNode("退出登录")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_27, [
                    _createTextVNode(_toDisplayString(pageData.userinfo.username), 1),
                    _hoisted_28
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_29, [
              _createVNode(_component_router_link, { to: "/user/login" }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              })
            ])),
        _createVNode(_component_router_link, { to: "/ucenter/my" }, {
          default: _withCtx(() => [
            _createTextVNode("个人中心")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})